import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offer-and-coupon-management',
  templateUrl: './offer-and-coupon-management.component.html',
  styleUrls: ['./offer-and-coupon-management.component.scss']
})
export class OfferAndCouponManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/offer-and-coupon-management/offer-and-coupon-management.component.ts